<template>
	<div>
		<swiper class="swiper_tab01" :options="swiperOption_tab01" ref="mySwiper_tab01">
			<swiper-slide :key="index" v-for="(item,index) in list">
				<component :is="item.component"></component>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	// 一级导航组件
	import home from '@/views/bookcity/home';
	import chunai from '@/views/bookcity/chunai';
	import yanqing from "@/views/bookcity/yanqing";
	import yansheng from '@/views/bookcity/yansheng';
	import cp from '@/views/bookcity/CP';
	export default {
		props: ['swiperIndex'],
		data() {
			const that = this
			return {
				list: [{
						component: home,
					},
					{
						component: yanqing,
					},
					{
						component: chunai,
					},
					{
						component: yansheng,
					},
					{
						component: cp,
					},
				],
				mySwiper: null,
				//轮播图配置
				swiperOption_tab01: {
					spaceBetween: 0,
					centeredSlides: true,
					direction: 'horizontal',
					autoplay: false,
					loop: false,
					threshold : 50,
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					observer: false,
					observeParents: false,
					// prevButton: ".swiper-button-prev",
					// nextButton: ".swiper-button-next",
					//滑动之后回调函数
					on: {
						slideChangeTransitionStart: function() {
							var swiper = that.$refs.mySwiper_tab01.$swiper;
							console.log(swiper.activeIndex, 'swiper.activeIndex')
							that.$emit('slideTab', swiper.activeIndex)
						},
					},
				},
			}
		},
		 computed: {
		    // 定义swiper，在下面就可以引用这个swiper了；
		    swiper: function () {
		      return this.$refs.mySwiper_tab01.$swiper
		    },
		  },
		watch: {
			swiperIndex(value, oldvalue) {
				// 接收 nav组件传过来的导航按钮索引，跳转到相应的内容区
				this.swiper.slideTo(value, 0, false)
			}
		},
		mounted() {
			this.swiper.slideTo(localStorage.getItem('navInde') || 0);
		},
		methods: {
		}
	}
</script>

<style scoped="scoped">
	.swiper-container{
		overflow-y: scroll;
	}
</style>
